import { FETCH_FCM_USER_SUBSCRIPTIONS, UPDATE_FCM_USER_SUBSCRIPTIONS, SET_DEVICE_FCM_TOKEN, DEVICE_FCM_TOKEN_SUPORTED } from "../actions/types";

const fcmSubscriptionData = (state = "loading", action) => {
  switch (action.type) {
    case FETCH_FCM_USER_SUBSCRIPTIONS:
      return action.payload || null;
    case UPDATE_FCM_USER_SUBSCRIPTIONS:
      return {...state, [action.packageId]: action.payload}
    default:
      return state;
  }
};

const fcmDeviceSubscriptionToken = (state = null, action) => {
  switch (action.type) {
    case SET_DEVICE_FCM_TOKEN:
      return action.payload ;
    default:
      return state;
  }
};

const fcmDeviceSubscriptionSupport = (state = true, action) => {
  switch (action.type) {
    case DEVICE_FCM_TOKEN_SUPORTED:
      return action.payload ;
    default:
      return state;
  }
};

export default {
  fcmSubscriptionData,
  fcmDeviceSubscriptionToken,
  fcmDeviceSubscriptionSupport
}



// WEBPACK FOOTER //
// ./src/reducers/fcmSubscriptionReducer.js